import {useLocation, useSearchParams, Location} from 'react-router-dom';
import {LinkedRoutes, getNormalizedRoute} from '@/navigation/Routes';
interface UseAppRouteArgs {
  check?: string;
}

function get_is_active(pathname?: string | null, args?: UseAppRouteArgs) {
  if (!pathname) return false;
  if (!args) return false;
  if (!args.check) return false;

  const checkRoute = args.check;
  const normalizedCheckRoute = getNormalizedRoute(checkRoute);
  if (!normalizedCheckRoute) return false;


  // isExactMatch
  if (pathname === normalizedCheckRoute) return true;
  
  // is Sub path
  if (pathname.startsWith(normalizedCheckRoute)){
    return true;
  }

  // is linked route
  const linkedRoute = LinkedRoutes[pathname];
  if (linkedRoute && linkedRoute === normalizedCheckRoute){
    return true;
  }
  return false
}

export function useAppRoute(args?: UseAppRouteArgs) {
  const location = useLocation();
  const [params] = useSearchParams();

  const pathname = getNormalizedRoute(location.pathname);
  let is_active = get_is_active(pathname, args);

  return {
    name: location.pathname,
    params,
    raw: location,
    isActive: is_active,
  };
}
